import { createFeature, createReducer, on } from '@ngrx/store';
import { actions } from './distribution.actions';

interface DistributionState {
    submitFormSuccess: boolean | null;
    submitFormLoading: boolean;
}

const initialState: DistributionState = {
    submitFormSuccess: null,
    submitFormLoading: false,
};

export const distributionState = createFeature({
    name: 'distribution',
    reducer: createReducer(
        initialState,
        on(actions.submitDistributionFormResponse, (state, action): DistributionState => {
            return {
                ...state,
                submitFormSuccess: action.success,
                submitFormLoading: false,
            };
        }),
        on(actions.submitDistributionFormLoading, (state, action): DistributionState => {
            return {
                ...state,
                submitFormLoading: action.loading,
            };
        }),
    ),
});
